import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";

import "@/shared/libs/plugins/date-picker/custom.css";

export default {
    install(app) {
        app.component("VueDatePicker", VueDatePicker);
    },
};
